//#region src/hooks/use-media-query/constants/breakpoint-queries.ts
var e = {
	isMobile: "(max-width: 743px)",
	isTablet: "(min-width: 744px) and (max-width: 1023px)",
	isDesktop: "(min-width: 1024px)"
};
//#endregion
export { e as breakpointQueries };
